import { runtimeEnv } from '@/utils/runtimeEnv'

const getApiBaseUrl = (): string => {
  return runtimeEnv.VITE_API_BASE_URL ? `${runtimeEnv.VITE_API_BASE_URL}/api` : '/api'
}

/**
 * Authentication service for SAML-based authentication.
 * In production, redirects to API's SAML login endpoint.
 * In development, uses fake login endpoint.
 */
export const authService = {
  /**
   * Initiates login flow:
   * - Production: Redirects to SAML login (full page redirect to IdP)
   * - Development: Redirects to fake login endpoint
   * Note defaults to origin + path instead of just path because of the cross-origin nature of SAML
   */
  login(returnUrl: string = `${window.location.origin}${window.location.pathname}`): void {
    const isDevelopment = import.meta.env.DEV;
    const apiBaseUrl = getApiBaseUrl();

    if (isDevelopment) {
      // Development: Use fake login
      window.location.href = `${apiBaseUrl}/auth/fake-login`;
    } else {
      // Production: SAML login with return URL
      const encodedReturnUrl = encodeURIComponent(returnUrl);
      window.location.href = `${apiBaseUrl}/saml/login?returnUrl=${encodedReturnUrl}`;
    }
  },

  /**
   * Initiates logout flow:
   * - Production: Redirects to SAML logout (single logout with IdP)
   * - Development: Clears session and redirects to home
   */
  logout(): void {
    const isDevelopment = import.meta.env.DEV;
    const apiBaseUrl = getApiBaseUrl();

    if (isDevelopment) {
      // Development: Just redirect to home (session cleared by server)
      window.location.href = '/';
    } else {
      // Production: SAML logout
      window.location.href = `${apiBaseUrl}/saml/logout`;
    }
  },
};
